//NewPage.js



import React from 'react';
import HeroSlider from '../../../components/web/HeroSlider/HeroSlider';
// import AI4Good from '../../components/web/AI4Good/AI4Good';
import News from './News.jsx';
// import AboutUs from '../../components/web/AboutUs/AboutUs';

const HomePage = () => {
  return (
    <>
      <section id="home">
        <HeroSlider />
      </section>

      <section id="news">
        <News />
      </section>

    </>
  );
};

export default HomePage;